import Vue from "vue";
import VueRouter from "vue-router";
import Index from "@/views/z-index.vue";
import About from "@/views/first/about.vue";
import About2 from "@/views/first/about2.0.vue";
import New from "@/views/second/new.vue";
import Story from "@/views/strory/Brand_Story.vue";
import Center from "@/views/center/index.vue";
import Add from "@/views/add/index.vue";
import XiangQing from "@/views/xiangqing/index.vue";
import GoodDetail from "@/views/xiangqing/detail.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: Index,
    children: [
      {
        path: "/page/index",
        name: "About",
        component: About,
      },
      {
        path: "/page/index/index",
        name: "About2",
        component: About2,
      },
      {
        path: "/page/index/news",
        name: " New ",
        component: New,
      },
      {
        path: "/page/index/goods",
        name: "Story",
        component: Story,
      },
      {
        path: "/page/index/shop",
        name: "Center",
        component: Center,
      },
      {
        path: "/page/index/add",
        name: "Add",
        component: Add,
      },
      {
        path: "/xiangqing",
        name: "XiangQing",
        component: XiangQing,
      },
      {
        path: "/goodDetail",
        name: "GoodDetail",
        component: GoodDetail,
      },
    ],
    redirect: "/page/index",
  },
];

const router = new VueRouter({
  routes,
});

export default router;
